import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  salesOrders: 'SalesOrders',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.salesOrders],
  endpoints: {
    getSalesOrders: {
      providesTags: result =>
        result && result.length > 0
          ? // successful query
            [
              ...result.map(salesOrder => ({
                type: TAG_TYPES.salesOrders,
                id: salesOrder.id,
              })),
              { type: TAG_TYPES.salesOrders, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'SalesOrders', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.salesOrders, id: 'LIST' }],
    },
    getSalesOrder: {
      providesTags: (result, error, { salesOrderId }) => [{ type: TAG_TYPES.salesOrders, id: salesOrderId }],
    },
    createSalesOrder: {
      invalidatesTags: [{ type: TAG_TYPES.salesOrders, id: 'LIST' }],
    },
    updateSalesOrder: {
      invalidatesTags: (result, error, { salesOrderId }) => [{ type: TAG_TYPES.salesOrders, id: salesOrderId }],
    },
    archiveSalesOrder: {
      invalidatesTags: (result, error, { salesOrderId }) => [
        { type: TAG_TYPES.salesOrders, id: salesOrderId },
        { type: TAG_TYPES.salesOrders, id: 'LIST' },
      ],
    },
    getSalesOrdersCsv: {},
    uploadSalesOrdersCsv: {
      invalidatesTags: () => [{ type: TAG_TYPES.salesOrders }],
    },
  },
})

export const useGetSalesOrdersCsvLazyQuery = api.endpoints.getSalesOrdersCsv.useLazyQuery

export const {
  useGetSalesOrdersQuery,
  useGetSalesOrderQuery,
  useCreateSalesOrderMutation,
  useUpdateSalesOrderMutation,
  useArchiveSalesOrderMutation,
  useUploadSalesOrdersCsvMutation,
} = api
